module.exports = __webpack_public_path__ + "static/media/Grey_FrontPage.c44ca6fd.jpg";